import { Utils } from "@/plugins/utils";

export default {
    namespaced: true,
    state: {
        of3: null,
        loading: false,
        showReport: false
    },
    getters: { },
    mutations: {
        set(state, of3) {
            state.of3 = of3
        },
        initForm(state) {
            state.of3 = null
        },
        showReport(state) {
            state.showReport = true
        },
        hideReport(state) {
            state.showReport = false
        },
        setLoading(state, loading) {
            state.loading = loading
        },
    },
    actions: {
        initForm({ commit }) {
            commit("initForm")
        },
        async find({ commit, dispatch }, of3peca) {
            commit("setLoading", true)
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Buscando histórico da peça", indeterminate: true }, { root: true })
            
            await this._vm.$axios.get(`/Printing/PieceHistory/Get/${of3peca}`)
            .then(response => {
                    let of3 = Utils.ValidateAxiosResponse(response.data);
                    if (of3) {
                        commit("set", of3)
                        commit("showReport")
                    } else {
                        commit("initForm")
                        commit("hideReport")
                    }
                })
                .catch((error) => {
                    commit("hideReport")
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                });

            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "Buscando histórico da peça", indeterminate: true }, { root: true })
            commit("setLoading", false)
        },
    }
}